// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__152Vm","footer":"Form_footer__pjP4B"};